import useForm from '@components/form/hooks/useForm';
import usePrevious from 'lib/src/hooks/usePrevious';
import useTimeout from 'lib/src/hooks/useTimeout';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { postLogin } from '@actions/auth/postLogin';
import { getAuthError, getAuthIsPosting, getAuthPostSuccess } from '@selectors/auth';

import LoginForm from './LoginForm';

const LoginFormContainer: React.FC = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const timeout = useTimeout();
    const location = useLocation<LoginRedirectState>();
    const from = location?.state?.from;
    const isPosting = useSelector(getAuthIsPosting);
    const postSuccess = useSelector(getAuthPostSuccess);
    const error = useSelector(getAuthError);
    let redirectURL = from?.pathname || '/';
    // stop potential redirect loop
    if (redirectURL.toLowerCase().includes('auth')) redirectURL = '/';
    const [formState, handleChange] = useForm({
        email: '',
        password: '',
    });

    const prevPostSuccess = usePrevious(postSuccess);
    useEffect(() => {
        if (!prevPostSuccess && postSuccess) {
            timeout(() => {
                history.push(redirectURL);
            }, 150);
        }
    }, [postSuccess, prevPostSuccess, history, redirectURL, from, timeout]);

    const customValidate = useCallback(() => {
        // eslint-disable-next-line
    }, [formState.email]);

    return (
        <LoginForm
            handleChange={handleChange}
            formState={formState}
            handleSubmit={handleSubmit}
            isPosting={isPosting}
            customValidate={customValidate}
            error={error}
        />
    );

    function handleSubmit() {
        dispatch(postLogin(formState));
    }
};

interface LoginRedirectState {
    from: {
        pathname: string;
        hash: string;
        search: string;
    };
}

export default LoginFormContainer;
